// The top-bar head's "Hi": a tiny store shared by the head (HeaderMascot) and its bubble
// (AssistantHello). The bubble starts the greeting once the 3D head is on screen; the head then "says"
// it (Talking for a beat) and nods with happy eyes (Done), then goes back to following the assistant.
import { useSyncExternalStore } from "react";

export type GreetingPhase = "none" | "talking" | "nod";

interface Greeting {
  headReady: boolean;
  phase: GreetingPhase;
}

const listeners = new Set<() => void>();
let greeting: Greeting = { headReady: false, phase: "none" };
let timer: number | undefined;

function update(next: Partial<Greeting>) {
  greeting = { ...greeting, ...next };
  for (const fn of listeners) fn();
}

export function setHeadReady() {
  if (!greeting.headReady) update({ headReady: true });
}

/** "Hi!" — about one syllable of mouth movement, then the happy nod. */
export function startGreeting() {
  window.clearTimeout(timer);
  update({ phase: "talking" });
  timer = window.setTimeout(() => update({ phase: "nod" }), 850);
}

export function endGreeting() {
  window.clearTimeout(timer);
  if (greeting.phase !== "none") update({ phase: "none" });
}

export function useGreeting(): Greeting {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => greeting,
  );
}
